export const SOUTH_AFRICA_TIME_ZONE = 'Africa/Johannesburg';
export const BUSINESS_HOURS = {
    orderingStartHour: 0,
    kitchenStartHour: 0,
    orderingEndHour: 24,
    operatingDays: [0, 1, 2, 3, 4, 5, 6],
};

const WEEKDAY_INDEX = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
};

function getSouthAfricaTimeParts(date = new Date()) {
    const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: SOUTH_AFRICA_TIME_ZONE,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    });

    const parts = formatter.formatToParts(date).reduce((accumulator, part) => {
        if (part.type !== 'literal') {
            accumulator[part.type] = part.value;
        }

        return accumulator;
    }, {});

    return {
        dayOfWeek: WEEKDAY_INDEX[parts.weekday],
        hour: Number(parts.hour),
        minute: Number(parts.minute),
    };
}

export function buildFallbackBusinessStatus(date = new Date()) {
    const { dayOfWeek, hour } = getSouthAfricaTimeParts(date);
    const isWeekday = BUSINESS_HOURS.operatingDays.includes(dayOfWeek);
    const canPlaceOrders = isWeekday
        && hour >= BUSINESS_HOURS.orderingStartHour
        && hour < BUSINESS_HOURS.orderingEndHour;
    const isWithinKitchenHours = isWeekday
        && hour >= BUSINESS_HOURS.kitchenStartHour
        && hour < BUSINESS_HOURS.orderingEndHour;
    const isEarlyOrderingWindow = canPlaceOrders && !isWithinKitchenHours;

    let statusCode = 'REGULAR_HOURS_CLOSED';
    let message = 'Ordering is currently unavailable.';

    if (isEarlyOrderingWindow) {
        statusCode = 'EARLY_ORDERING';
        message = 'Orders are open for testing.';
    } else if (canPlaceOrders) {
        statusCode = 'OPEN';
        message = 'Ordering is open for testing.';
    }

    return {
        evaluatedAt: date.toISOString(),
        timezone: SOUTH_AFRICA_TIME_ZONE,
        businessHours: BUSINESS_HOURS,
        canPlaceOrders,
        isWithinKitchenHours,
        isEarlyOrderingWindow,
        isClosed: !canPlaceOrders,
        statusCode,
        banner: {
            tone: canPlaceOrders ? 'open' : 'closed',
            message,
        },
        activeClosure: null,
    };
}

export function formatClosureDateTime(value) {
    return new Intl.DateTimeFormat('en-ZA', {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: SOUTH_AFRICA_TIME_ZONE,
    }).format(new Date(value));
}

export function formatDateInputValue(value) {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function formatTimeInputValue(value) {
    const date = new Date(value);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
}
